<template>
    <v-container>

        <v-card-title>
            <h2>Parliaments</h2>
            <v-spacer></v-spacer>
            <v-text-field v-show="this.$store.state.OBJ_APPLICATION_INIT_LOADED" v-model="search" append-icon="search" label="Search" single-line hide-details></v-text-field>
        </v-card-title>

        <template>
            <v-card v-if="!this.$store.state.OBJ_APPLICATION_INIT_LOADED">
                <v-container fluid>
                    <v-layout row wrap>
                        <v-flex xs12>
                            <div class="loader"></div>
                        </v-flex>
                    </v-layout>
                </v-container>
            </v-card>
        </template>
        <br>
        <div v-show="this.$store.state.OBJ_APPLICATION_INIT_LOADED">
            <v-data-table :headers="HEADERS" :items="PARLIAMENTS" :rows-per-page-items="ROWS_LISTITEMS" :pagination.sync="PAGINATION" v-on:update:pagination="UPDATE_PAGINATION" :search="search" class="elevation-1">
                <template v-slot:items="props">
                    <td class="text-xs-left">{{ props.item.PID }}</td>
                    <td class="text-xs-left">{{ props.item.Name }}</td>
                    <td class="text-xs-left">{{ props.item.DateElection | stringDateFormat}}</td>
                    <td class="text-xs-left">{{ props.item.DateOpening | stringDateFormat}}</td>
                    <td class="text-xs-left">{{ props.item.DateDissolution | stringDateFormat}}</td>
                    <td class="text-xs-left">{{ props.item.ParliamentEnd | stringDateFormat}}</td>
                </template>
            </v-data-table>

            <v-btn class="csvButton_hide" color="secondary" @click="EXPORTTOCSV()" v-on:keyup.enter="EXPORTTOCSV()" v-if="PARLIAMENTS.length">
                <v-icon aria-hidden="true" class="mr-1">text_snippet</v-icon>
                <span >Download as CSV</span>
            </v-btn>
        </div>
    </v-container>
</template>

<script>
    window.scrollTo(0, 0);

    export default {

        data() {

            return {

                search: '',
                CSV_HEADERS: ['Parliament', 'Name', 'DateElection', 'DateOpening', 'DateDissolution'],  // " + this.$store.state.STRING_CRLF,
                CSV_FILENAME: "Handbook-Parliaments",

                ROWS_LISTITEMS: [5, 10, 50, {
                    "text": "$vuetify.dataIterator.rowsPerPageAll",
                    "value": -1
                }],

                PAGINATION: {
                    rowsPerPage: this.$store.state.ROWS_PER_PAGE
                },

                HEADERS: [{
                    text: 'Parliament',
                    value: 'PID',
                    align: 'left',
                    sortable: true
                }, {
                    text: 'Name',
                    value: 'Name',
                    align: 'left',
                    sortable: true
                },
                {
                    text: 'Date of Election',
                    value: 'DateElection',
                    align: 'left',
                    sortable: true,
                    sort: (a, b) => this.$moment(a) > this.$moment(b)
                },
                {
                    text: 'Opening of Parliament',
                    value: 'DateOpening',
                    align: 'left',
                    sortable: true,
                    sort: (a, b) => this.$moment(a) > this.$moment(b)
                },
                {
                    text: 'Dissolution of Parliament',
                    value: 'DateDissolution',
                    align: 'left',
                    sortable: true,
                    sort: (a, b) => this.$moment(a) > this.$moment(b)
                },
                {
                    text: 'Last day of Parliament',
                    value: 'ParliamentEnd',
                    align: 'left',
                    sortable: true,
                    sort: (a, b) => this.$moment(a) > this.$moment(b)
                },
                ],
            }
        },

        methods: {
            EXPORTTOCSV() {
                this.$gtag.event('parliaments download csv', {
                    'event_category': 'downloads',
                    'event_label': 'parliaments search csv download',
                    'value': 1
                });
                this.$store.dispatch('GETCSV', { DATA: this.PARLIAMENTS, HEADERS: this.CSV_HEADERS, FILENAME: this.CSV_FILENAME })
            },
            UPDATE_PAGINATION: function (options) {
                this.$gtag.event('parliaments pagination items per page', {
                    'event_category': 'filters',
                    'event_label': `items per page: ${options.rowsPerPage}`,
                    'value': 1
                });
                this.$gtag.event('parliaments pagination page', {
                    'event_category': 'filters',
                    'event_label': `page: ${options.page}`,
                    'value': 1
                });
            }
        },

        computed: {
            PARLIAMENTS() {
                return this.$store.getters.GET_PARLIAMENTS
            }
        },
    }
</script>

<style lang="stylus" scoped>
    .v-progress-circular {
        margin: 1rem
    }

    a {
        color: #fff;
        text-decoration: underline;
    }
</style>
